// Formata data como HH:MM:SS para api
const formatHourApi = hour => {
  let newhour = hour.split(":")
  return newhour[0] + 
    ":" + (newhour[1] ? newhour[1]: "00" ) + 
    ":" + (newhour[2] ? newhour[2]: "00" )
}

export default formatHourApi